{
	"createOrder": {
		"stopPrice": "Stop price",
		"limitPrice": "Limit price",
		"amountTransaction": "Transaction amount",
		"availableWithLeverage": "Available with Leverage",
		"approximateSum": "Approximate Total",
		"side": {
			"buy": "Buy",
			"sell": "Sell"
		},
		"errors": {
			"stopPriceZero": "Stop price cannot be zero",
			"limitPriceZero": "Limit price cannot be zero",
			"qtyZero": "Quantity cannot be zero",
			"invalidTakeProfit": "Invalid Take Profit value",
			"invalidStopLoss": "Invalid Stop Loss value",
			"orderCreationFailed": "Failed to create order",
			"orderCreationSuccess": "Order {{symbol}} created successfully",
			"maxQty": "Value exceeds quantity available in your portfolio",
			"trailValueZero": "Trail value cannot be zero"
		}
	}
}
